export default __webpack_public_path__ + "static/keys-5ec15e75bbdc2c9d3ddb21c960246f9d.svg";